import React, { createContext } from "react";
import { BetaForm as useBetaForm } from "@reusejs/react";

const searchForm: any = () => {
  return useBetaForm({
    asset_type: "",
    sub_asset_type: "",
    state: "",
    city: "",
    locality: "",
    reserve_price: "",
    institutes: "",
    filter_by: "",
    sort_by: "",
    total: "",
    auction_start_date_unix_timestamp: "",
    // property_date_type:"",
    // // todo add this key
  });
};

// create context
const Context = createContext({});

// context provider
const ContextProvider = (props: any) => {
  return (
    <Context.Provider value={{ searchForm: searchForm() }}>
      {props?.children}
    </Context.Provider>
  );
};

export { Context, ContextProvider };
